module.exports = __webpack_public_path__ + "img/image4.daef6b1c.jpg";